import React, { Component } from 'react';
import Classes from './style.module.css';
import Radio from '@mui/material/Radio';
import './thousandthree.css'
import { GoSearch } from "react-icons/go";

export default class Thousandtwo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defVal: this.props.defdata,
            value: this.getValues(props.filterData),
            searchTerm: ''
        };
    }

   
    getValues = (values) => {
        if (!values) return [];
        return values.includes(',') ? values.split(',') : [values];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filterData !== this.props.filterData) {
            this.setState({
                value: this.getValues(this.props.filterData),
                defVal: this.props.defdata
            });
            this.setState({searchTerm:""})
        }
    }

    storeValue = (e) => {
        this.setState({ defVal: e.target.value });
        this.props.onChange(e.target.value);
    }

    getID = (val) => {
        return val.replace(/\s+/g, '') + new Date().getTime();
    }

    onSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    }

    render() {
        const { value, searchTerm, defVal } = this.state;
        const filteredValues = value.filter(val => 
            val.toLowerCase().includes(searchTerm.toLowerCase())
        );

        return (
            <div >
              <div className='textsearch'>
      <input
        className="textinp2"
        type="text"
        placeholder="Search..."
        value={this.state.searchTerm}
        onChange={(e)=>this.onSearchChange(e)}
       
        autoFocus={true}
      />
      <GoSearch 
        className="searchtextinp"
        
      />
    </div>
    <hr style={{ color: "grey" }} />
    <div className={ Classes.overflow} style={{ maxHeight: "300px", 
    overflowY: "auto",  
    paddingBottom: "10px", 
    scrollBehavior: "smooth" }}>
    {filteredValues.length > 0 ? (
                    filteredValues.map((val, index) => (
                        <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
<Radio
      checked={val === defVal} 
        id={this.getID(val)} 
        onChange={this.storeValue}
        value={val}
        name="radio-buttons"
        inputProps={{ 'aria-label': 'A' }}
        sx={{
            p: 0.5,
            color: '#29b6f6', 
            '&.Mui-checked': {
              color: '#29b6f6',
            },
          }}
      />
                            <label  htmlFor={this.getID(val)} style={{ paddingLeft: "10px", cursor: 'pointer' }}>{val}</label>
                        </div>
                    ))
                ) : (
                    <p>No results found</p>
                )}
    </div>  
            </div>
        );
    }
}
